import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import { ActionLockedIconWithTooltip } from '../../../../../../common/components/ActionLocked/ActionLockedIconWithTooltip';
import { ItemLogo } from '../../../../../../common/components/ItemLogo/ItemLogo';
import { useStore } from '../../../../../app/data/root.store';
import { CloseIcon } from '../../../VaultFilters/icons';
import {
    AddButton,
    RemoveTagButton,
    TagCategory,
    TagCategoryTitle,
    TagPill,
    TagsList,
    TagText
} from '../shared/TagCategory.styles';
import { LinkedItemModal } from './LinkedItemModal/LinkedItemModal';

export const AttachedToItemsTagCategory = observer(({ attachedItems, onUpdate, fileName, onOpenLinkedItemDrawer }) => {
    const { uiStore, userStore, metadataStore } = useStore();
    const [isModalOpen, setIsModalOpen] = useState(false);

    useEffect(() => {
        metadataStore.fetchData();
    }, [metadataStore]);

    const handleAddTag = () => {
        if (userStore.isActionBlockedByRole('editVaultFileMetadata')) {
            userStore.setShowLimitedSharedAccess(true);
            return;
        }
        if (uiStore.isDesktopView) {
            setIsModalOpen(true);
        } else {
            onOpenLinkedItemDrawer(attachedItems);
        }
    };

    const handleTagClick = () => {
        if (userStore.isActionBlockedByRole('editVaultFileMetadata')) {
            userStore.setShowLimitedSharedAccess(true);
            return;
        }
        if (uiStore.isDesktopView) {
            setIsModalOpen(true);
        } else {
            onOpenLinkedItemDrawer(attachedItems);
        }
    };

    const handleModalSave = async (selectedAssets) => {
        try {
            const formattedItems = selectedAssets.map(asset => ({
                id: asset.id,
                name: asset.title || asset.name || 'Unnamed Asset',
                title: asset.title || asset.name || 'Unnamed Asset',
                logoUrl: asset.logoUrl || null,
                logoBase64: asset.logoBase64 || null,
                categoryId: asset.categoryId,
                categoryClass: {
                    color: asset.categoryClass?.color || asset.classColor,
                    icon: asset.categoryClass?.icon || asset.classIcon
                }
            }));
            await onUpdate(formattedItems);
        } catch (error) {
            console.error('Failed to save linked items:', error);
        }
        setIsModalOpen(false);
    };

    const handleRemoveTag = async (itemToRemove, event) => {
        if (userStore.isActionBlockedByRole('editVaultFileMetadata')) {
            userStore.setShowLimitedSharedAccess(true);
            return;
        }
        event.stopPropagation();
        try {
            const updatedItems = attachedItems.filter(item => item.id !== itemToRemove.id);
            await onUpdate(updatedItems);
        } catch (error) {
            console.error('Failed to remove linked item:', error);
        }
    };

    return (
        <TagCategory>
            <TagCategoryTitle>Attached to Items {userStore.isActionBlockedByRole('editVaultFileMetadata') && <ActionLockedIconWithTooltip iconColor={'#ACB1BB'} isRoleBlocked={true} marginLeft={'0px'} />}</TagCategoryTitle>
            {attachedItems.length > 0 && (
                <TagsList>
                    {attachedItems.map((item, index) => (
                        <TagPill key={item.id || index} onClick={handleTagClick}>
                            <ItemLogo item={item} customStyles={{ marginRight: '0px', width: '20px', minWidth: '20px', height: '20px', svg: { width: '12px', height: '12px' } }} />
                            <TagText>{item.name || item.title}</TagText>
                            <RemoveTagButton onClick={(event) => handleRemoveTag(item, event)}>
                                <CloseIcon />
                            </RemoveTagButton>
                        </TagPill>
                    ))}
                </TagsList>
            )}
            <AddButton onClick={handleAddTag}>+ Add</AddButton>
            {isModalOpen && (
                <LinkedItemModal
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                    fileName={fileName}
                    selectedItems={attachedItems}
                    onSave={handleModalSave}
                />
            )}
        </TagCategory>
    );
}); 